import { DROP_ITEM } from "../2-material/_selectors";
import disableMaterial from "../2-material/disableMaterial";
import enableMaterial from "../2-material/enableMaterial";
import type { materials } from "../2-material/materials";
import selectAllElements from "../dom/selectAllElements";
import { STYLE_ITEMS } from "./_selectors";
import chooseStyleSpansHandleClick from "./chooseStyleSpansHandleClick";
import hatStyles from "./hatStyles";

export type Materials = typeof materials;

function chooseStyleSetup({ materials }: { materials: Materials }) {
	// Get all material spans
	const materialSpans: NodeListOf<HTMLSpanElement> = selectAllElements(DROP_ITEM);

	// Get all style spans
	const chooseStyleSpans = selectAllElements<HTMLSpanElement>(STYLE_ITEMS);
	console.log(
		`Found ${chooseStyleSpans?.length || 0} style elements with selector "${STYLE_ITEMS}"`,
	);

	// First, hide ALL materials from ALL styles initially
	const allStyles = Object.keys(hatStyles);
	for (const style of allStyles) {
		const styleMaterials = materials[style as string];
		if (styleMaterials) {
			console.log(`Initially disabling materials for ${style}:`, styleMaterials);
			for (const material of styleMaterials) {
				const materialSpan = Array.from(materialSpans).find(
					(span) => span.getAttribute("data-value")?.toLowerCase() === material.toLowerCase(),
				);
				if (materialSpan) {
					materialSpan.style.display = "none";
					materialSpan.classList.add("hide");
				}
			}
		}
	}

	// Then show only snapback materials by default
	console.log("Enabling default snapback materials:", materials.snapback);
	enableMaterial(materials.snapback, materialSpans);

	// Add click handlers for style selection
	if (chooseStyleSpans && chooseStyleSpans.length > 0) {
		for (const span of chooseStyleSpans) {
			console.log(`Adding click handler to style: ${span.getAttribute("data-value")}`);
			span.addEventListener("click", () => {
				console.log(`Style clicked: ${span.getAttribute("data-value")}`);
				chooseStyleSpansHandleClick(span, materials, materialSpans, hatStyles);
			});
		}
	} else {
		console.warn("No style elements found to attach click handlers!");
	}
}

export default chooseStyleSetup;
